import React, { useEffect, useState } from 'react'
import './Popular.css'
import Item from '../Item/Item'
import API_BASE_URL from '../../config'

const Popular = () => {
  const [popularProducts, setPopularProducts] = useState([]);
  
  useEffect(() => {
    const fetchPopularProducts = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/popularinwomen`);

        if (!response.ok) {
          throw new Error(`Failed to fetch popular products, status: ${response.status}`);
        }

        const data = await response.json();

        // Process data to calculate discount percentage
        const processedData = data.map(item => {
          const oldPrice = parseFloat(item.old_price) || 0;
          const newPrice = parseFloat(item.new_price) || 0;
          let discountPercentage = 0;
          
          // Calculate discount percentage if both prices are valid
          if (oldPrice > 0 && newPrice > 0 && newPrice < oldPrice) {
            discountPercentage = Math.round(((oldPrice - newPrice) / oldPrice) * 100);
          }
          
          return {
            ...item,
            displayImage: item.image || item.main_image || (item.images && item.images[0]) || '/images/placeholder.jpg',
            discountPercentage: discountPercentage
          };
        });
        
        setPopularProducts(processedData);
      } catch (error) {
        // Fail gracefully in the UI instead of throwing an unhandled error
        setPopularProducts([]);
      }
    };

    fetchPopularProducts();
  }, []);
  
  return (
    <div className='popular'>
      <h1>POPULAR IN WOMEN</h1>
      <hr/>
      <div className="popular-items">
        {popularProducts.map((item, i) => (
          <Item 
            key={i} 
            id={item.id} 
            name={item.name} 
            image={item.displayImage}
            new_price={item.new_price}
            old_price={item.old_price}
            discountPercentage={item.discountPercentage} // Pass discount to Item component
          />
        ))}
      </div>
    </div>
  )
}

export default Popular

